const developmentApiBaseUrl = "http://127.0.0.1:5099";

function isLoopbackHost(hostname: string) {
  const normalized = hostname.toLowerCase();
  return normalized === "localhost" || normalized === "127.0.0.1" || normalized === "[::1]";
}

export function apiBaseUrl() {
  const configured = process.env.INSPARKLE_API_BASE_URL?.trim();
  if (!configured) {
    return process.env.NODE_ENV === "development" ? developmentApiBaseUrl : "";
  }

  try {
    const url = new URL(configured);
    const supportedProtocol = url.protocol === "http:" || url.protocol === "https:";
    const unsafeAddress = !supportedProtocol || Boolean(url.username || url.password || url.search || url.hash);
    const insecureProductionRemote = process.env.NODE_ENV === "production" && url.protocol !== "https:" && !isLoopbackHost(url.hostname);
    if (unsafeAddress || insecureProductionRemote) return "";

    const path = url.pathname === "/" ? "" : url.pathname.replace(/\/+$/, "");
    return `${url.origin}${path}`;
  } catch {
    return "";
  }
}
